import React from 'react';


function FooterMenu(props) {
  return (
    <React.Fragment>
      <p className="footerTitle">{props.title}</p>
      <ul className="footerMenu">
        { (props.menu && props.menu.nodes && props.menu.nodes.length > 0) &&
          props.menu.nodes.map(child => {
            return (
              <li className={child.cssClasses} key={child.id}><a href={child.url}>{child.label}</a></li>
            )
          })
        }
      </ul>
    </React.Fragment>
  );
}
export default FooterMenu;